<template>
  <div class="auth-page">
    <!-- Snackbar for notifications -->
    <v-snackbar
      v-model="showSnackBar"
      color="#ff6f3c"
      right
      :timeout="timeout"
      class="custom-snackbar"
    >
      <div class="d-flex align-center justify-space-between w-100 py-1">
        <span class="snackbar-text">{{ msg }}</span>
        <v-btn icon small @click="showSnackBar = false" class="ml-4 close-snack-btn">
          <v-icon color="white" small>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <div class="auth-shell">
      <!-- ============ LEFT : HERO ============ -->
      <section class="hero-pane">
        <div class="hero-image"></div>
        <div class="hero-scrim"></div>

        <router-link to="/" class="back-home back-home--hero">
          <v-icon size="16" class="back-home__icon">mdi-arrow-left</v-icon>
          <span>Back to Home</span>
        </router-link>

        <div class="hero-copy">
          <h1 class="hero-title">
            Protecting <span class="hero-title__accent">Wildlife,</span><br />
            Securing Lives
          </h1>
          <p class="hero-subtitle">
            Sarpa MP &ndash; Snake Rescue &amp; Human-Wildlife Conflict
            Management System
          </p>

          <div class="hero-note">
            <span class="hero-note__badge">
              <v-icon size="15">mdi-shield-check</v-icon>
            </span>
            <span class="hero-note__text">
              Together, we can create a safer coexistence with nature.
            </span>
          </div>
        </div>
      </section>

      <!-- ============ RIGHT : LOGIN FORM ============ -->
      <section class="form-pane">
        <router-link to="/" class="back-home back-home--compact">
          <v-icon size="15" class="back-home__icon">mdi-arrow-left</v-icon>
          <span>Back to Home</span>
        </router-link>

        <div class="form-inner">
          <div class="form-card">
            <!-- Brand -->
            <div class="brand">
              <div class="brand__row">
                <img
                  :src="require('../assets/sarpamp.png')"
                  alt="SARPA MP"
                  class="brand__mark brand__mark--sarpa"
                />
                <span class="brand__name">SARPA<span class="brand__name-accent">.MP</span></span>
              </div>

              <div class="brand__row brand__row--gov">
                <img
                  :src="require('../assets/mpgovernment.png')"
                  alt="Government of Madhya Pradesh"
                  class="brand__mark brand__mark--gov"
                />
                <span class="brand__gov">GOVERNMENT OF MP</span>
              </div>
            </div>

            <!-- Divider with crest -->
            <div class="crest-divider">
              <span class="crest-divider__line"></span>
              <v-icon class="crest-divider__crest" size="22">mdi-shield-check</v-icon>
              <span class="crest-divider__line"></span>
            </div>

            <!-- Heading -->
            <div class="form-heading">
              <h2 class="form-heading__title">Welcome <span class="form-heading__accent">Back</span></h2>
              <p class="form-heading__sub">Log in to access the admin portal</p>
            </div>

            <!-- Credentials -->
            <v-form class="login-form" @submit.prevent="validateInput">
              <v-text-field
                v-model="emailId"
                class="auth-field"
                color="#f0770d"
                placeholder="Username"
                autocomplete="username"
                outlined
                hide-details
                prepend-inner-icon="mdi-account-outline"
              ></v-text-field>

              <v-text-field
                v-model="password"
                class="auth-field mt-4"
                color="#f0770d"
                placeholder="Password"
                autocomplete="current-password"
                outlined
                hide-details
                prepend-inner-icon="mdi-lock-outline"
                :append-icon="show3 ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                :type="show3 ? 'text' : 'password'"
                @click:append="show3 = !show3"
              ></v-text-field>

              <div class="form-meta">
                <v-checkbox
                  v-model="rememberMe"
                  class="remember-check"
                  color="#f0770d"
                  label="Remember me"
                  hide-details
                ></v-checkbox>

                <router-link to="/forgotPassword" class="forgot-link">
                  Forgot Password?
                </router-link>
              </div>

              <v-btn
                class="login-btn"
                type="submit"
                block
                depressed
                dark
                height="54"
              >
                <span>LOGIN</span>
                <v-icon right size="18" class="login-btn__arrow">mdi-arrow-right</v-icon>
              </v-btn>
            </v-form>

            <!-- Divider -->
            <div class="or-divider">
              <span class="or-divider__line"></span>
              <span class="or-divider__label">or continue with</span>
              <span class="or-divider__line"></span>
            </div>

            <!-- Assurance strip -->
            <div class="trust-row">
              <span class="trust-chip">
                <v-icon size="14">mdi-lock-check-outline</v-icon>
                Encrypted Session
              </span>
              <span class="trust-chip">
                <v-icon size="14">mdi-account-key-outline</v-icon>
                Authorised Access Only
              </span>
            </div>

            <!-- Support -->
            <p class="form-help">
              Trouble signing in?
              <router-link to="/supportPage" class="form-help__link">Get support</router-link>
            </p>
          </div>
        </div>
      </section>
    </div>

    <!-- ============ FOOTER ============ -->
    <footer class="page-footer">
      <span class="page-footer__copy">&copy; {{ currentYear }} Sarpa MP. All rights reserved.</span>
      <span class="page-footer__sep">|</span>
      <span class="page-footer__credit">
        Designed &amp; Maintained by
        <a href="https://leopardtechlabs.com" target="_blank" rel="noopener" class="page-footer__link">
          Leopard Tech Labs
        </a>
      </span>
    </footer>
  </div>
</template>

<script>
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      otp: null,
      phone: null,
      emailId: null,
      password: null,
      rememberMe: false,
      show1: false,
      show2: true,
      show3: false,
      show4: false,
      currentYear: new Date().getFullYear(),
    };
  },
  mounted() {
    this.phone = this.$route.query.phone;
    var remembered = localStorage.getItem("rememberedUsername");
    if (remembered) {
      this.emailId = remembered;
      this.rememberMe = true;
    }
  },
  methods: {
    validateInput() {
      if (!this.emailId) {
        this.msg = "Please Provide Username.";
        this.showSnackBar = true;
        return;
      }
      if (!this.password) {
        this.msg = "Please Provide Password.";
        this.showSnackBar = true;
        return;
      } else {
        this.login();
      }
    },
    login() {
      axios({
        method: "post",
        url: "/platform/login/",
        data: {
          username: this.emailId,
          password: this.password,
        },
      })
        .then((response) => {
          if (response.data.heartbeat) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            if (this.rememberMe)
              localStorage.setItem("rememberedUsername", this.emailId);
            else localStorage.removeItem("rememberedUsername");
            //OLD WILDWATCH REQ
            localStorage.setItem("token", response.data.data.token);
            localStorage.setItem("userRole", response.data.data.type);
            this.$store.commit("userData", response.data.userDetails);
            this.$store.commit("loginUser", response.data.data.token);
            this.$store.commit("userRole", response.data.data.type);
            this.$store.commit("mainRole", response.data.data.role);
            this.$store.commit("userName", response.data.data.username);
            if (response.data.data.role == "official")
              this.$router.push("/officers/sarpadashboard");
            else if (response.data.data.type == "admin")
              this.$router.push("/Sarpa/dashboard");
            else if (response.data.data.type == "RRT")
              this.$router.push("/officers/sarpadashboard");
            else if (response.data.data.role == "MedicalOfficer")
              this.$router.push("/medicalOfficers/stockVenom");
            else if (response.data.data.role == "District Emergency Officer")
              this.$router.push("/DistrictEmergencyOfficer/districtDashboard");
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          store.commit("appLoading", false);
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
/* ============================================================
   Tokens
   ============================================================ */
.auth-page {
  --brand: #f0770d;
  --brand-dark: #d96608;
  --brand-light: #ff8a3d;
  --brand-deep: #d9660a;
  --ink: #1b1614;
  --ink-soft: #6d625c;
  --hairline: #e6cdb6;
  --field-border: #e8dcd1;
}

/* ============================================================
   Page frame
   ============================================================ */
.auth-page {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  background: #0b0908;
  padding: 18px 18px 0 18px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family: "sofiaProRegular", sans-serif;
}

.auth-shell {
  display: flex;
  flex: 1;
  min-height: 0;
  width: 100%;
  border-radius: 14px;
  overflow: hidden;
  background: #f9efe4;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
}

/* ============================================================
   Hero pane
   ============================================================ */
.hero-pane {
  position: relative;
  flex: 1.25;
  min-width: 0;
  overflow: hidden;
  background: #150f0a;
}

.hero-image {
  position: absolute;
  inset: 0;
  background-image: url("../assets/mp_login_image.png");
  background-size: cover;
  background-position: 42% center;
}

.hero-scrim {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(10, 7, 4, 0.9) 0%,
    rgba(12, 8, 5, 0.55) 32%,
    rgba(12, 8, 5, 0.05) 62%,
    rgba(0, 0, 0, 0) 100%
  );
}

.hero-copy {
  position: absolute;
  left: 48px;
  right: 48px;
  bottom: 52px;
  z-index: 2;
}

.hero-title {
  font-family: "sofiaProBold", "sofiaProSemiBold", sans-serif;
  font-size: 40px;
  line-height: 1.16;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.6px;
  margin: 0 0 18px 0;
}

.hero-title__accent {
  color: var(--brand-deep);
}

.hero-subtitle {
  font-family: "sofiaProRegular", sans-serif;
  font-size: 15px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.84);
  max-width: 340px;
  margin: 0 0 26px 0;
}

.hero-note {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  max-width: 320px;
  padding: 14px 18px;
  border-radius: 10px;
  background: rgba(16, 11, 7, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.hero-note__badge {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid rgba(217, 102, 10, 0.7);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.hero-note__badge .v-icon {
  color: var(--brand-deep) !important;
}

.hero-note__text {
  font-family: "sofiaProRegular", sans-serif;
  font-size: 13px;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.92);
}

/* ============================================================
   Back to Home
   ============================================================ */
.back-home {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  text-decoration: none;
  font-family: "sofiaProMedium", "sofiaProRegular", sans-serif;
  font-size: 13px;
  transition: background 0.2s ease, transform 0.2s ease;
}

.back-home__icon {
  transition: transform 0.2s ease;
}

.back-home:hover .back-home__icon {
  transform: translateX(-3px);
}

/* over the photo */
.back-home--hero {
  position: absolute;
  top: 28px;
  left: 28px;
  z-index: 3;
  padding: 9px 18px 9px 14px;
  border-radius: 999px;
  /* beats the global `a { color: #000 !important }` in appStyle.css */
  color: #ffffff !important;
  background: rgba(14, 10, 7, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.back-home--hero .v-icon {
  color: #ffffff !important;
}

.back-home--hero:hover {
  background: rgba(14, 10, 7, 0.88);
}

/* inside the cream pane — only when the hero is hidden */
.back-home--compact {
  display: none;
  position: absolute;
  top: 22px;
  left: 20px;
  z-index: 3;
  color: var(--ink) !important;
}

.back-home--compact .v-icon {
  color: var(--ink) !important;
}

/* ============================================================
   Form pane
   ============================================================ */
.form-pane {
  position: relative;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 32px 0 32px;
  overflow-y: auto;
  background-color: #fbf1e6;
  background-image: url("../assets/mp_log_card_image.png");
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
}

.form-inner {
  width: 100%;
  max-width: 462px;
  margin: auto 0;
}

/* the form sits on a raised glass card so the pane reads as composed
   rather than as one large empty field of cream */
.form-card {
  padding: 40px 44px 34px 44px;
  border-radius: 20px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.84) 0%,
    rgba(255, 251, 246, 0.68) 100%
  );
  border: 1px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 24px 55px rgba(122, 72, 26, 0.14),
    0 2px 6px rgba(122, 72, 26, 0.05);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

/* --- brand --- */
.brand {
  margin-bottom: 22px;
}

.brand__row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.brand__row--gov {
  margin-top: 10px;
  gap: 10px;
}

.brand__mark {
  flex-shrink: 0;
}

.brand__mark--sarpa {
  width: 34px;
  height: 34px;
  object-fit: contain;
}

/* the crest sits inside a letterboxed white canvas — crop the padding away
   with cover, then multiply the leftover white into the cream background */
.brand__mark--gov {
  width: 36px;
  height: 36px;
  object-fit: cover;
  mix-blend-mode: multiply;
}

.brand__name {
  font-family: "sofiaProBold", "sofiaProSemiBold", sans-serif;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.6px;
  color: var(--ink);
  line-height: 1;
}

.brand__name-accent {
  color: var(--brand);
}

.brand__gov {
  font-family: "sofiaProSemiBold", sans-serif;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: var(--ink);
  line-height: 1;
}

/* --- divider with crest --- */
.crest-divider {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 26px;
}

.crest-divider__line {
  flex: 1;
  height: 1px;
  background: var(--hairline);
}

.crest-divider__crest {
  color: var(--brand) !important;
  flex-shrink: 0;
}

/* --- heading --- */
.form-heading {
  text-align: center;
  margin-bottom: 26px;
}

.form-heading__title {
  font-family: "sofiaProBold", "sofiaProSemiBold", sans-serif;
  font-size: 29px;
  font-weight: 700;
  color: var(--ink);
  letter-spacing: -0.4px;
  line-height: 1.2;
  margin: 0 0 7px 0;
}

.form-heading__accent {
  color: var(--brand);
}

.form-heading__sub {
  font-family: "sofiaProRegular", sans-serif;
  font-size: 13.5px;
  color: var(--ink-soft);
  margin: 0;
}

/* --- remember / forgot row --- */
.form-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 16px 0 20px 0;
}

.remember-check {
  margin: 0 !important;
  padding: 0 !important;
  flex-shrink: 0;
}

.forgot-link {
  font-family: "sofiaProMedium", "sofiaProRegular", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: var(--brand) !important;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.2s ease;
}

.forgot-link:hover {
  color: var(--brand-dark) !important;
  text-decoration: underline;
}

/* --- submit --- */
.login-btn {
  background: linear-gradient(180deg, #f7841a 0%, #ec6f08 100%) !important;
  border-radius: 8px !important;
  font-family: "sofiaProSemiBold", sans-serif !important;
  font-size: 14px !important;
  font-weight: 700;
  letter-spacing: 1.2px;
  box-shadow: 0 8px 20px rgba(240, 119, 13, 0.28) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease !important;
}

.login-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 26px rgba(240, 119, 13, 0.36) !important;
}

.login-btn:active {
  transform: translateY(1px);
}

.login-btn__arrow {
  transition: transform 0.2s ease;
}

.login-btn:hover .login-btn__arrow {
  transform: translateX(4px);
}

/* --- support line --- */
.form-help {
  margin: 18px 0 0 0;
  text-align: center;
  font-family: "sofiaProRegular", sans-serif;
  font-size: 12.5px;
  color: #85786f;
}

.form-help__link {
  color: var(--brand) !important;
  text-decoration: none;
  font-weight: 600;
  margin-left: 3px;
}

.form-help__link:hover {
  text-decoration: underline;
}

/* --- or divider --- */
.or-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 24px 0 18px 0;
}

.or-divider__line {
  flex: 1;
  height: 1px;
  background: var(--hairline);
}

.or-divider__label {
  font-family: "sofiaProRegular", sans-serif;
  font-size: 12px;
  color: #9c8d82;
  white-space: nowrap;
}

/* --- assurance chips --- */
.trust-row {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 0;
}

.trust-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 13px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.62);
  border: 1px solid rgba(232, 205, 182, 0.85);
  font-family: "sofiaProRegular", sans-serif;
  font-size: 11.5px;
  letter-spacing: 0.2px;
  color: #7d6f65;
  white-space: nowrap;
}

.trust-chip .v-icon {
  color: var(--brand) !important;
}

/* ============================================================
   Footer
   ============================================================ */
.page-footer {
  flex-shrink: 0;
  width: 100%;
  padding: 15px 20px 16px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 4px 12px;
  font-family: "poppinsregular", sans-serif;
  font-size: 12px;
  color: #8b7f76;
  text-align: center;
}

.page-footer__sep {
  color: #4a423c;
}

.page-footer__link {
  color: var(--brand-light) !important;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s ease;
}

.page-footer__link:hover {
  color: var(--brand) !important;
  text-decoration: underline;
}

/* ============================================================
   Vuetify overrides
   ============================================================ */
::v-deep .auth-field.v-text-field--outlined > .v-input__control > .v-input__slot {
  background: #ffffff !important;
  border-radius: 10px !important;
  min-height: 52px !important;
  box-shadow: 0 1px 2px rgba(27, 22, 20, 0.04);
}

::v-deep .auth-field.v-text-field--outlined fieldset {
  border-color: var(--field-border) !important;
  border-width: 1px !important;
  border-radius: 10px !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease !important;
}

::v-deep .auth-field.v-text-field--outlined:not(.v-input--is-focused) fieldset:hover {
  border-color: #d9c6b6 !important;
}

::v-deep .auth-field.v-text-field--outlined.v-input--is-focused fieldset {
  border-color: var(--brand) !important;
  border-width: 1px !important;
  box-shadow: 0 0 0 3px rgba(240, 119, 13, 0.12);
}

::v-deep .auth-field input {
  color: var(--ink) !important;
  font-family: "sofiaProRegular", sans-serif !important;
  font-size: 14.5px !important;
}

::v-deep .auth-field input::placeholder {
  color: #a9998f !important;
  opacity: 1;
}

::v-deep .auth-field .v-input__prepend-inner {
  margin-top: 13px !important;
  padding-right: 10px !important;
}

::v-deep .auth-field .v-input__append-inner {
  margin-top: 13px !important;
}

::v-deep .auth-field .v-icon {
  color: #b7a69b !important;
  font-size: 20px !important;
  transition: color 0.2s ease;
}

::v-deep .auth-field.v-input--is-focused .v-input__prepend-inner .v-icon {
  color: var(--brand) !important;
}

/* remember-me checkbox */
::v-deep .remember-check .v-input--selection-controls__input {
  width: 18px;
  height: 18px;
  margin-right: 8px;
}

::v-deep .remember-check .v-input--selection-controls__input .v-icon {
  font-size: 19px;
  color: #b7a69b;
}

::v-deep .remember-check.v-input--is-label-active .v-input--selection-controls__input .v-icon {
  color: var(--brand) !important;
}

::v-deep .remember-check .v-input--selection-controls__ripple {
  display: none;
}

::v-deep .remember-check label {
  font-family: "sofiaProRegular", sans-serif;
  font-size: 13px;
  color: #4c423d;
}

/* snackbar */
.custom-snackbar ::v-deep .v-snack__wrapper {
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
}

.snackbar-text {
  font-family: "sofiaProMedium", sans-serif;
  font-size: 13.5px;
}

.close-snack-btn {
  background: rgba(255, 255, 255, 0.08) !important;
}

/* ============================================================
   Responsive
   ============================================================ */

/* Laptop — 1366 x 768 */
@media (max-width: 1439px) {
  .hero-title {
    font-size: 32px;
  }
  .hero-subtitle {
    font-size: 13.5px;
    max-width: 300px;
    margin-bottom: 22px;
  }
  .hero-copy {
    left: 34px;
    right: 34px;
    bottom: 40px;
  }
  .hero-note {
    max-width: 290px;
    padding: 12px 15px;
  }
  .hero-note__text {
    font-size: 12px;
  }
  .form-inner {
    max-width: 344px;
  }
  .form-card {
    padding: 32px 30px 24px 30px;
  }
  .form-heading__title {
    font-size: 25px;
  }
}

/* Tablet — 768 x 1024 (split layout is kept) */
@media (max-width: 1023px) {
  .auth-page {
    padding: 12px 12px 0 12px;
  }
  .page-footer {
    font-size: 11px;
    padding: 12px 16px 13px 16px;
    gap: 3px 9px;
  }
  .hero-pane {
    flex: 1;
  }
  .hero-image {
    background-position: 46% center;
  }
  .hero-title {
    font-size: 22px;
    margin-bottom: 12px;
  }
  .hero-subtitle {
    font-size: 12px;
    max-width: 220px;
    margin-bottom: 16px;
  }
  .hero-copy {
    left: 22px;
    right: 22px;
    bottom: 26px;
  }
  .hero-note {
    max-width: 220px;
    padding: 10px 12px;
    gap: 10px;
  }
  .hero-note__badge {
    width: 24px;
    height: 24px;
  }
  .hero-note__text {
    font-size: 11px;
  }
  .back-home--hero {
    top: 18px;
    left: 18px;
    padding: 7px 14px 7px 11px;
    font-size: 12px;
  }
  .form-pane {
    padding: 28px 20px 0 20px;
  }
  .form-inner {
    max-width: 392px;
  }
  .form-card {
    padding: 26px 24px 20px 24px;
    border-radius: 16px;
  }
  .or-divider {
    margin: 18px 0 14px 0;
  }
  .form-help {
    margin-top: 14px;
    font-size: 11.5px;
  }
  .trust-row {
    gap: 7px;
  }
  .trust-chip {
    padding: 5px 10px;
    font-size: 10.5px;
    gap: 5px;
  }
  .brand__name {
    font-size: 17px;
  }
  .brand__gov {
    font-size: 12.5px;
  }
  .brand__mark--sarpa,
  .brand__mark--gov {
    width: 27px;
    height: 27px;
  }
  .crest-divider {
    margin-bottom: 20px;
  }
  .form-heading {
    margin-bottom: 20px;
  }
  .form-heading__title {
    font-size: 21px;
  }
  .form-heading__sub {
    font-size: 12px;
  }
  ::v-deep .auth-field.v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 44px !important;
  }
  ::v-deep .auth-field .v-input__prepend-inner,
  ::v-deep .auth-field .v-input__append-inner {
    margin-top: 10px !important;
  }
  .login-btn {
    height: 44px !important;
  }
}

/* Mobile — hero is dropped, the form takes the full screen */
@media (max-width: 719px) {
  .auth-page {
    padding: 0;
  }
  .auth-shell {
    border-radius: 0;
    box-shadow: none;
  }
  .hero-pane {
    display: none;
  }
  .back-home--compact {
    display: inline-flex;
  }
  .form-pane {
    flex: 1;
    padding: 68px 26px 24px 26px;
    background-position: center bottom;
  }
  .form-inner {
    max-width: 414px;
  }
  .form-card {
    padding: 30px 26px 24px 26px;
    border-radius: 17px;
  }
  .page-footer {
    font-size: 10.5px;
    padding: 11px 14px 12px 14px;
    gap: 2px 8px;
  }
  .form-heading__title {
    font-size: 23px;
  }
  ::v-deep .auth-field.v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 48px !important;
  }
  ::v-deep .auth-field .v-input__prepend-inner,
  ::v-deep .auth-field .v-input__append-inner {
    margin-top: 12px !important;
  }
  .login-btn {
    height: 48px !important;
  }
}

/* Short viewports — let the pane scroll instead of clipping */
@media (max-height: 660px) {
  .form-pane {
    justify-content: flex-start;
    padding-top: 24px;
  }
  .form-inner {
    margin: 0 0 20px 0;
  }
  .form-card {
    padding: 24px 26px 18px 26px;
  }
  .brand {
    margin-bottom: 16px;
  }
  .crest-divider,
  .form-heading {
    margin-bottom: 16px;
  }
  .form-help {
    margin-top: 13px;
  }
  .trust-row {
    margin-top: 13px;
  }
}
</style>
